import React, { useContext, useEffect, useState } from "react";

const AssignmentContext = React.createContext();
const SetAssignmentContext = React.createContext();

export function useAssignment() {
  return useContext(AssignmentContext);
}

export function useSetAssignment() {
  return useContext(SetAssignmentContext);
}

export function AssignmentProvider({ children }) {
  const [assignment, setAssignment] = useState({});

  return (
    <AssignmentContext.Provider value={assignment}>
      <SetAssignmentContext.Provider value={setAssignment}>
        {children}
      </SetAssignmentContext.Provider>
    </AssignmentContext.Provider>
  );
}
